export const storageKeys = {
  wishlist: 'wishlist',
  customerHash: 'survey_hash',
  surveysSeen: 'surveys_seen'
};

export const urlParams = {
  accessToken: 'productListAccessToken'
};



// WEBPACK FOOTER //
// ./src/util/constants.js